/**
 * Medix Site Theme Configuration
 *
 * Default theme for Medix deployment
 * Colors extracted from original RA2 system
 */

import { SiteThemeConfig } from '@shared/providers/theme/types';

export const medixTheme: SiteThemeConfig = {
  siteType: 'medix',
  siteName: 'メディックス',

  // A2 (鍼灸) Theme - Rich Amber
  // Dark, warm, premium look with high contrast
  A2: {
    name: 'A2',
    displayName: 'レセプロ-A2',
    colors: {
      primary: '#CC6A00', // Header background (deep orange)
      primaryHover: '#B85E00', // Header hover state
      primaryDark: '#803800', // Footer background (dark burnt orange)
      secondary: '#E07818', // Buttons, accents (warm orange)
      sidebarBg: '#A85800', // Sidebar background (dark orange)
      sidebarBgInactive: '#D4B896', // Sidebar background for inactive state
      sidebarText: '#FFF5E6', // Sidebar text (warm white)
      menuOpen: 'rgba(0, 0, 0, 0.12)', // Expanded menu background
      menuHover: 'rgba(224, 120, 24, 0.2)', // Menu item hover (orange tint)
      menuActive: 'rgba(224, 120, 24, 0.35)', // Active menu item (orange highlight)
      sectionHeader: '#B85E00', // Section header background (deep orange)
      sectionHeaderText: '#FFF5E6', // Section header text (warm white)
    },
    logoPath: '/images/logo.png',
    sidebarWidth: 'w-60',
  },

  // R2 (マッサージ) Theme - Magenta/Pink from RA2
  // Header: #812959, Sidebar: #c8648a, Buttons: #114861, Primary: #4fada7
  R2: {
    name: 'R2',
    displayName: 'レセプロ-R2',
    colors: {
      primary: '#812959', // Header background (magenta/purple)
      primaryHover: '#6b224a', // Header hover state
      primaryDark: '#5a1d3e', // Footer background
      secondary: '#114861', // Buttons (dark blue)
      sidebarBg: '#c8648a', // Sidebar background (pink)
      sidebarBgInactive: '#E5C5D4', // Sidebar background for inactive state
      sidebarText: '#ffffff', // Sidebar text (white)
      menuOpen: 'rgba(0, 0, 0, 0.1)', // Expanded menu background (dark overlay)
      menuHover: 'rgba(0, 0, 0, 0.15)', // Menu item hover
      menuActive: 'rgba(0, 0, 0, 0.25)', // Active menu item
      sectionHeader: '#812959', // Section header background (magenta - matches R2 theme)
      sectionHeaderText: '#ffffff', // Section header text (white)
    },
    logoPath: '/images/logo_r2.png',
    sidebarWidth: 'w-60',
  },

  // Service Type Selector styling
  serviceSelector: {
    backgroundColor: '#1f2937', // Dark gray (gray-800)
    buttonActiveOpacity: 'ff', // Full opacity when selected
    buttonInactiveOpacity: '40', // 40% opacity when not selected
  },
};
